import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { StructuredData } from './structured-data';

/**
 * WebSite schema with SearchAction for sitelinks search box.
 * Enables Google to show a search box directly in search results for the site.
 *
 * @see https://schema.org/WebSite
 * @see https://developers.google.com/search/docs/appearance/structured-data/sitelinks-searchbox
 */
export const WebSiteSchema = () => {
    const { siteInfo, searchPage } = useContext(AppContext);

    const isAtosCare = siteInfo.siteType === 'atos-care';
    const siteName = isAtosCare ? 'Atos Care' : 'Atos Medical';
    const baseUrl = `https://${siteInfo.currentDomain}`;

    const searchUrl = searchPage?.url;

    const schema = () => {
        const baseSchema: Record<string, unknown> = {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: siteName,
            url: baseUrl,
        };

        // Only add SearchAction if search page is configured
        if (searchUrl) {
            baseSchema.potentialAction = {
                '@type': 'SearchAction',
                target: {
                    '@type': 'EntryPoint',
                    urlTemplate: `${baseUrl}${searchUrl}?s={search_term_string}`,
                },
                'query-input': 'required name=search_term_string',
            };
        }

        return baseSchema;
    };

    return (
        <Show when={siteInfo.currentDomain}>
            <StructuredData data={schema()} />
        </Show>
    );
};
